<template>
    <div id="app" class="bg-offwhite flex flex-col min-h-screen">
        <nav class="flex flex-col md:flex-row justify-start md:justify-between font-sans text-black z-50 p-4" :class="menu_open ? 'h-screen md:h-20' : 'h-[4.5rem] md:h-20'">
            <div id="nav-brand">
                <router-link to="/">
                    <img v-if="!header_negative" class="h-10 w-auto" :src="require(`@/assets/img/home/logo.svg`)" alt="" />
                    <img v-else class="h-10 w-auto" :src="require(`@/assets/img/home/logo-neg.svg`)" alt="" />
                </router-link>
            </div>
            <button class="block md:hidden absolute top-6 right-6" @click="menu_open = !menu_open">
                <span :class="menu_open ? 'hidden' : 'block'"
                    ><svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="1.5" x2="29" y2="1.5" stroke="#3E3838" stroke-width="3" />
                        <line y1="11.5" x2="29" y2="11.5" stroke="#3E3838" stroke-width="3" />
                        <line y1="21.5" x2="29" y2="21.5" stroke="#3E3838" stroke-width="3" />
                    </svg>
                </span>
                <span :class="menu_open ? 'block' : 'hidden'"
                    ><svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1.93934" y1="24.9393" x2="24.9393" y2="1.93934" stroke="#3E3838" stroke-width="3" />
                        <line x1="2.06066" y1="1.93934" x2="25.0607" y2="24.9393" stroke="#3E3838" stroke-width="3" />
                    </svg>
                </span>
            </button>
            <ul class="flex flex-col md:flex-row items-start md:items-center h-10 mt-20 md:mt-0" :class="[header_negative ? 'text-offwhite' : 'text-black', menu_open ? 'md:block block' : 'md:flex hidden']">
                <li class="flex flex-col md:flex-row items-start md:items-center h-36 md:h-10">
                    <button
                        class="text-2xl md:text-lg font-bold uppercase"
                        @click="
                            intro_active = !intro_active
                            issues_active = false
                        "
                    >
                        Introdução
                    </button>
                    <ul id="intro_list" :class="intro_active ? 'flex' : 'hidden'" class="flex flex-col md:flex-row items-start md:items-center h-32 md:h-10 font-light text-base uppercase">
                        <li class="ml-4 mt-2 md:mt-0">
                            <router-link to="/apresentacao">Apresentação</router-link>
                        </li>
                        <li class="ml-4 mt-2 md:mt-0">
                            <router-link to="/muito-prazer-fapesp">Muito prazer, FAPESP</router-link>
                        </li>
                        <li class="ml-4 mt-2 md:mt-0">
                            <router-link to="/linha-do-tempo">Linha do tempo</router-link>
                        </li>
                        <!-- <li class="ml-4 mt-2 md:mt-0">
                            <router-link to="/resumo-executivo">Resumo executivo</router-link>
                        </li> -->
                    </ul>
                </li>
                <span class="hidden md:block text-2xl md:text-lg font-bold uppercase mx-4">/</span>
                <li class="flex flex-col md:flex-row items-start md:items-center h-10 mt-10 md:mt-0">
                    <button
                        class="text-2xl md:text-lg font-bold uppercase"
                        @click="
                            issues_active = !issues_active
                            intro_active = false
                        "
                    >
                        Fascículos
                    </button>
                    <ul id="issues_list" :class="issues_active ? 'flex' : 'hidden'" class="flex-col md:flex-row items-start md:items-center h-10 font-light text-base uppercase">
                        <li v-for="(issue, index) in issues" :key="issue.slug" class="issue_menu_link mt-2 md:mt-0">
                            <router-link class="ml-4" v-if="issue.published" :to="{ name: 'SingleIssueView', params: { slug: issue.slug, issueData: issue } }"> #{{ index + 1 }}</router-link>
                        </li>
                        <li class="ml-4 mt-4 md:mt-0">
                            <router-link class="text-lg md:text-base font-light" :to="{ name: 'FasciculosView', params: { slug: 'fasciculos', issue: issues } }"> Ver todos </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <keep-alive>
            <router-view class="font-sans text-black grow" :issues="issues" />
        </keep-alive>
        <footer class="font-sans text-black text-center">FAPESP 60 anos • Ciência, cultura e desenvolvimento</footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            intro_active: false,
            issues_active: false,
            header_negative: false,
            menu_open: false,
            teste: 'Teste ok',
            issues: [
                {
                    id: 1,
                    title: 'Seis décadas de realizações',
                    slug: 'fasciculo01',
                    month: 'Julho',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Nik Neves',
                    posts: [
                        {
                            postTitle: 'FAPESP, um patrimônio da população paulista',
                            postSlug: 'fapesp-um-patrimonio-da-populacao-paulista',
                            author: 'Marco Antonio Zago',
                            comp: 'FA1Texto1',
                            negative: false,
                        },
                        {
                            postTitle: 'A FAPESP e o compromisso com a vida',
                            postSlug: 'compromisso-com-a-vida',
                            author: null,
                            comp: 'FA1Texto2',
                            negative: true,
                        },
                        {
                            postTitle: 'A favor do conhecimento',
                            postSlug: 'a-favor-do-conhecimento',
                            author: null,
                            comp: 'FA1Texto3',
                        },
                        {
                            postTitle: 'A locomotiva de uma arrancada histórica',
                            postSlug: 'a-locomotiva-de-uma-arrancada-historica',
                            author: null,
                            comp: 'FA1Texto4',
                        },
                    ],
                },
                {
                    title: 'DNA da ciência paulista',
                    slug: 'fasciculo02',
                    month: 'Agosto',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Movimento 1989 / Suzane Lopes',
                    posts: [
                        {
                            postTitle: 'A FAPESP e as ciências sociais',
                            postSlug: 'a-FAPESP-e-as-ciencias-sociais',
                            author: 'José de Souza Martins',
                            comp: 'FA2Texto1',
                        },
                        {
                            postTitle: 'Um modelo de inspiração para as FAPs',
                            postSlug: 'um-modelo-de-inspiracao-para-as-faps',
                            author: 'Vanderlan S. Bolzani',
                            comp: 'FA2Texto2',
                        },
                        {
                            postTitle: 'Um percurso singular',
                            postSlug: 'um-percurso-singular',
                            author: null,
                            comp: 'FA2Texto3',
                        },
                        {
                            postTitle: 'A semente das agências estaduais de fomento',
                            postSlug: 'a-semente-das-agencias-estaduais-de-fomento',
                            author: null,
                            comp: 'FA2Texto4',
                        },
                        {
                            postTitle: 'As marcas da fundação paulista',
                            postSlug: 'as-marcas-da-fundacao-paulista',
                            author: null,
                            comp: 'FA2Texto5',
                        },
                    ],
                },
                {
                    title: 'Pioneirismo digital',
                    slug: 'fasciculo03',
                    month: 'Setembro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Daniel Kondo',
                    posts: [
                        {
                            postTitle: 'Da Pirajussara à Pio XI',
                            postSlug: 'da-pirajussara-a-pio-xi',
                            author: 'Demi Getschko',
                            comp: 'FA3Texto1',
                        },
                        {
                            postTitle: 'A cidadania do nada',
                            postSlug: 'a-cidadania-do-nada',
                            author: 'João Carlos Salles',
                            comp: 'FA3Texto2',
                        },
                        {
                            postTitle: 'A “bobagem” de Oscar Sala foi um ato fundador da internet no Brasil',
                            postSlug: 'a-bobagem-de-oscar-sala-foi-um-ato-fundador-da-internet-no-brasil',
                            author: null,
                            comp: 'FA3Texto3',
                        },
                        {
                            postTitle: 'As raízes acadêmicas de uma revolução tecnológica',
                            postSlug: 'as-raizes-academicas-de-uma-revolucao-tecnologica',
                            author: null,
                            comp: 'FA3Texto4',
                        },
                        {
                            postTitle: 'Inteligência em TI, o backbone da inovação',
                            postSlug: 'inteligencia-em-ti-o-backbone-da-inovacao',
                            author: null,
                            comp: 'FA3Texto5',
                        },
                    ],
                },
                {
                    title: 'Grandes projetos, grandes resultados',
                    slug: 'fasciculo04',
                    month: 'Outubro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Catarina Bessel',
                    posts: [
                        {
                            postTitle: 'A ciência a serviço da sociedade',
                            postSlug: 'a-ciencia-a-servico-da-sociedade',
                            author: 'Paulo Artaxo',
                            comp: 'FA4Texto1',
                        },
                        {
                            postTitle: 'Geração e transferência de conhecimento',
                            postSlug: 'geracao-e-transferencia-de-conhecimento',
                            author: 'Marta Arretche',
                            comp: 'FA4Texto2',
                        },
                        {
                            postTitle: 'A arte de multiplicar cérebros e recursos',
                            postSlug: 'a-arte-de-multiplicar-cerebros-e-recursos',
                            author: null,
                            comp: 'FA4Texto3',
                        },
                        {
                            postTitle: 'Contribuições brasileiras a um ambiente futuro mais saudável',
                            postSlug: 'contribuicoes-brasileiras-a-um-ambiente-futuro-mais-saudavel',
                            author: null,
                            comp: 'FA4Texto4',
                        },
                        {
                            postTitle: 'Ousadia para crescer e inovar',
                            postSlug: 'ousadia-para-crescer-e-inovar',
                            author: null,
                            comp: 'FA4Texto5',
                        },
                    ],
                },
                {
                    title: 'Políticas públicas baseadas em evidências',
                    slug: 'fasciculo05',
                    month: 'Novembro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Elisa Carareto',
                    posts: [
                        {
                            postTitle: 'Crise trava apoio à ciência no país',
                            postSlug: 'crise-trava-apoio-a-ciencia-no-pais',
                            author: 'Olival Freire Jr.',
                            comp: 'FA5Texto1',
                        },
                        {
                            postTitle: 'Evidências, sim; ideologias, não',
                            postSlug: 'evidencia-sim-ideologias-nao',
                            author: 'Helena Nader',
                            comp: 'FA5Texto2',
                        },
                        {
                            postTitle: 'Ciência e gestão pública',
                            postSlug: 'ciencia-e-gestao-publica',
                            author: null,
                            comp: 'FA5Texto3',
                        },
                        {
                            postTitle: 'Atenção à qualidade do ensino público',
                            postSlug: 'atencao-a-qualidade-do-ensino-publico',
                            author: null,
                            comp: 'FA5Texto4',
                        },
                        {
                            postTitle: 'Ciência a serviço da saúde pública',
                            postSlug: 'ciencia-a-servico-da-saude-publica',
                            author: null,
                            comp: 'FA5Texto5',
                        },
                    ],
                },
                {
                    title: 'Contribuição social, cultural e artística',
                    slug: 'fasciculo06',
                    month: 'Dezembro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: 'Ana Matsusaki',
                    posts: [
                        {
                            postTitle: 'As humanidades podem melhorar as ciências humanas',
                            postSlug: 'as-humanidades-podem-melhorar-as-ciencias-humanas',
                            author: 'Renato Janine Ribeiro',
                            comp: 'FA6Texto1',
                        },
                        {
                            postTitle: 'Desobedecer é preciso (Notas sobre a pesquisa artística)',
                            postSlug: 'desobedecer-e-preciso',
                            author: 'Giselle Beiguelman',
                            comp: 'FA6Texto2',
                        },
                        {
                            postTitle: 'Um abrigo científico para a cultura',
                            postSlug: 'um-abrigo-cientifico-para-a-cultura',
                            author: null,
                            comp: 'FA6Texto3',
                        },
                        {
                            postTitle: 'Ciências humanas e sociais, pilares da democracia',
                            postSlug: 'ciencias-humanas-e-sociais-pilares-da-democracia',
                            author: null,
                            comp: 'FA6Texto4',
                        },
                        {
                            postTitle: 'Um tratamento especial para as artes',
                            postSlug: 'um-tratamento-especial-para-as-artes',
                            author: null,
                            comp: 'FA6Texto5',
                        },
                    ],
                },
                {
                    title: 'Inovação e empreendedorismo',
                    slug: 'fasciculo07',
                    month: 'Janeiro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: '',
                    posts: [
                        {
                            postTitle: 'Ligando pesquisa com inovação',
                            postSlug: 'ligando-pesquisa-com-inovacao',
                            author: 'Sergio Salles-Filho',
                            comp: 'FA7Texto1',
                        },
                        {
                            postTitle: 'O desejo de empreender precisa ser realizado',
                            postSlug: 'o-desejo-de-empreender-precisa-ser-realizado',
                            author: 'Geciane Porto',
                            comp: 'FA7Texto2',
                        },
                        {
                            postTitle: 'A inovação em valorizar a inovação',
                            postSlug: 'a-inovacao-em-valorizar-a-inovacao',
                            author: null,
                            comp: 'FA7Texto3',
                        },
                        {
                            postTitle: 'A invenção da inovação como programa',
                            postSlug: 'a-invencao-da-inovacao-como-programa',
                            author: null,
                            comp: 'FA7Texto4',
                        },
                        {
                            postTitle: 'Empreendedorismo de conhecimento',
                            postSlug: 'empreendedorismo-de-conhecimento',
                            author: null,
                            comp: 'FA7Texto5',
                        },
                    ],
                },
                {
                    title: 'Diversidade e inclusão',
                    slug: 'fasciculo08',
                    month: 'Fevereiro',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: '',
                    posts: [
                        {
                            postTitle: 'A violência nossa de cada dia',
                            postSlug: 'a-violencia-nossa-de-cada-dia',
                            author: 'Eunice Prudente',
                            comp: 'FA8Texto1',
                        },
                        {
                            postTitle: 'O impacto das cotas na universidade pública',
                            postSlug: 'o-impacto-das-cotas-na-universidade-publica',
                            author: null,
                            comp: 'FA8Texto3',
                        },
                        {
                            postTitle: 'Pesquisa e inclusão de povos indígenas',
                            postSlug: 'pesquisa-e-inclusao-de-povos-indigenas',
                            author: 'Gersem Baniwa',
                            comp: 'FA8Texto2',
                        },
                        {
                            postTitle: 'Um levante científico contra a desigualdade de gênero',
                            postSlug: 'um-levante-cientifico-contra-a-desigualdade-de-genero',
                            author: null,
                            comp: 'FA8Texto4',
                        },
                        {
                            postTitle: 'Saberes antigos, novos protagonistas',
                            postSlug: 'saberes-antigos-novos-protagonistas',
                            author: null,
                            comp: 'FA8Texto5',
                        },
                    ],
                },
                {
                    title: 'Lições da pandemia',
                    slug: 'fasciculo09',
                    month: 'Março',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: '',
                    posts: [
                        {
                            postTitle: 'Ciência deve vir antes da política',
                            postSlug: 'ciencia-deve-vir-antes-da-politica',
                            author: 'Dimas Covas',
                            comp: 'FA9Texto1',
                        },
                        {
                            postTitle: 'Reação em velocidade recorde',
                            postSlug: 'reacao-em-velocidade-recorde',
                            author: null,
                            comp: 'FA9Texto3',
                        },
                        {
                            postTitle: 'A ciência de prontidão',
                            postSlug: 'a-ciencia-de-prontidao',
                            author: null,
                            comp: 'FA9Texto4',
                        },
                        {
                            postTitle: 'Ciência básica com resultados práticos',
                            postSlug: 'ciencia-basica-com-resultados-praticos',
                            author: 'Mayana Zatz',
                            comp: 'FA9Texto2',
                        },
                        {
                            postTitle: 'Conhecimento para orientar políticas e reduzir desigualdades',
                            postSlug: 'conhecimento-para-orientar-politicas-e-reduzir-desigualdades',
                            author: null,
                            comp: 'FA9Texto5',
                        },
                    ],
                },
                {
                    title: 'De olho no futuro',
                    slug: 'fasciculo10',
                    month: 'Abril',
                    published: true,
                    cover: '',
                    background: '',
                    banner: '',
                    artist: '',
                    posts: [
                        {
                            postTitle: 'Ciência e inovação na construção do futuro ',
                            postSlug: 'ciencia-e-inovacao-na-construcao-do-futuro ',
                            author: 'Luiz Davidovich ',
                            comp: 'FA10Texto1',
                        },
                        {
                            postTitle: 'Transição verde e transição digital',
                            postSlug: 'transicao-verde-e-transicao-digital',
                            author: null,
                            comp: 'FA10Texto3',
                        },
                        {
                            postTitle: 'Novos critérios para novos desafios da ciência',
                            postSlug: 'novos-criterios-para-novos-desafios-da-ciencia',
                            author: null,
                            comp: 'FA10Texto4',
                        },
                        {
                            postTitle: 'Virá que eu vi: pensamentos, sem certeza, sobre o futuro',
                            postSlug: 'vira-que-eu-vi-pensamentos-sem-certeza-sobre-o-futuro ',
                            author: 'Lilia Moritz Shwarcz',
                            comp: 'FA10Texto2',
                        },
                        {
                            postTitle: 'O tecido do conhecimento',
                            postSlug: 'o-tecido-do-conhecimento',
                            author: null,
                            comp: 'FA10Texto5',
                        },
                    ],
                },
            ],
        }
    },
    methods: {
        openMenu: function () {},
    },
    watch: {
        menu_open: function () {
            if (this.menu_open == true) {
                document.body.style.overflowY = 'hidden'
            } else {
                document.body.style.overflowY = 'scroll'
            }
        },
        $route: function (to, from) {
            this.issues_active = false
            this.intro_active = false
            if (to.name == 'SingleIssueView') {
                this.header_negative = true
                this.issue_slug = this.$route.params.slug
            } else if (to.name == 'SinglePostView') {
                if (to.params.author != undefined) {
                    this.header_negative = false
                } else {
                    this.header_negative = true
                }
            } else {
                this.header_negative = false
            }
        },
    },
}
</script>

<style lang="postcss">
.issue_menu_link::before {
    content: 'Fascículo';
    @apply ml-4 inline md:hidden;
}
</style>
